import script from "./TheDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDashboard.vue?vue&type=script&setup=true&lang=js"

import "./TheDashboard.vue?vue&type=style&index=0&id=f8f56b04&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8f56b04"]])

export default __exports__